import { isAfter, isWithinInterval } from 'date-fns'
import { pushLog } from './pushLog';

export const getCurrentStoreName = () => window.location.pathname.split('/')[1];
export const getCartTableId = () => {
  const store = getCurrentStoreName();
  const map = JSON.parse(sessionStorage.getItem('cart_table_id') || '{}');
  return map[store] || {}
}
export const setCartTableId = ({ cartId, tableId }) => {
  const store = getCurrentStoreName();
  const map = JSON.parse(sessionStorage.getItem('cart_table_id') || '{}');
  const data = { cartId, tableId };
  map[store] = data;
  sessionStorage.setItem('cart_table_id', JSON.stringify(map))
}
export const clearCartTableId = () => {
  const store = getCurrentStoreName();
  const map = JSON.parse(sessionStorage.getItem('cart_table_id') || '{}');
  delete map[store]
  sessionStorage.setItem('cart_table_id', JSON.stringify(map))
}

// 设置留言过滤特殊字符
export const setCommit = str => {
  if (!str || str === null || str.replace(/\s/g, '') === '') return '';
  const reg = /[0-9a-zA-Z,'.-\s]/g;
  const match = str.match(reg);
  return match ? str.match(reg).join('') : '';
};

export function limitImgUrl(url = '', width = 400) {
  if (
    !url ||
    url.indexOf('http') < 0 ||
    url.indexOf('//') < 0 ||
    url.endsWith('svg')
  ) {
    return url;
  }
  if (url.indexOf('static.bakmigm.co.id') < 0) {
    return url;
  }
  if (!url.includes('x-oss-process')) {
    let newUrl = url;
    newUrl += newUrl.includes('?') ? '&' : '?';
    newUrl += `x-oss-process=image/resize,w_${width}`;
    return newUrl;
  }
  return url;
}

export function inRange(min = 0, max = 10) {
  return min + (Math.random() * (max - min))
}


export function isSameStoreForInit() {
  const tableData = localStorage?.getItem('tableData');
  const { storeName } = JSON.parse(tableData);
  const store = window.location.pathname.split('/')[1];
  console.log(tableData, window.location.pathname)
  return store === storeName;
}
// TODO: 使用Map存储店铺和桌号的映射，解决多个tab桌号串数据
export function getTable() {
  if (process.env.SERVER) return;
  const map = JSON.parse(localStorage.getItem('tableData') || '{}')
  const currentStore = getCurrentStoreName();
  const tableObj = map[currentStore];
  if (!tableObj) return ''
  try {
    const { tableNumber, expires } = tableObj;
    // 过期
    if (new Date() - expires > 0) {
      pushLog({
        key: '[GET_TABLE EXEC]',
        expires,
        date: new Date(),
        'date-expire': new Date() - expires,
        currentStore,
        vuex: localStorage.getItem('vuex')
      });
      return '';
    }
    return tableNumber;
  } catch (e) {
    console.log(e);
    pushLog({
      key: '[GET_TABLE CATCH_ERROR]',
      e: JSON.stringify(e),
      ee: e?.toString(),
      vuex: localStorage.getItem('vuex')
    });
    // 解析失败当成单纯存了 桌号
    return '';
  }
}

export function setTable(tableNumber, eefectiveTime = 1000 * 60 * 60 * 24) {
  const map = JSON.parse(localStorage.getItem('tableData') || '{}')
  const currentStore = getCurrentStoreName();
  map[currentStore] = {
    tableNumber,
    storeName: currentStore,
    expires: +new Date() + eefectiveTime
  }
  return localStorage.setItem('tableData', JSON.stringify(map));
}

export function clearTable() {
  const map = JSON.parse(localStorage.getItem('tableData') || '{}')
  const currentStore = getCurrentStoreName();
  delete map[currentStore]
  localStorage.setItem('tableData', JSON.stringify(map))
}


export function openUrl(url) {
  window.open(url);
  // const a = document.createElement('a');
  // a.href = url;
  // a.target = '_blank';
  // a.click();
}

export function getToken(app) {
  return app?.token || localStorage.getItem('token');
}

export function scrollToActiveEl() {
  setTimeout(() => {
    if (document.activeElement?.scrollIntoViewIfNeeded) {
      document.activeElement?.scrollIntoViewIfNeeded();
    } else if (document.activeElement?.scrollIntoView) {
      document.activeElement?.scrollIntoView()
    }
  }, 200)
}

export function getServiceType() {
  if (process.env.SERVER) return;
  const vuex = JSON.parse(localStorage.getItem('vuex') || '{}');
  return vuex?.Menu?.accessStatus;
}

export function imgToBase64(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = '';
    img.onload = function () {
      const canva = document.createElement('canvas');
      canva.width = img.width;
      canva.height = img.height;
      const ctx = canva.getContext('2d');
      ctx.drawImage(img, 0, 0, img.width, img.height);
      const base64 = canva.toDataURL('image/png');
      resolve(base64);
    }
    img.onerror = reject;
    img.src = url;
  })
}


const bannerConfig = [
//  {
//    enBanner: limitImgUrl('https://static.bakmigm.co.id/menu-buyer/order/horego-banner-plp.png', 500),
//    idBanner: limitImgUrl('https://static.bakmigm.co.id/menu-buyer/order/horego-banner-plp.png', 500),
//    bannerLink: 'https://horego.onelink.me/BDBE/kng1j2ol',
//  },
//   {
//     enBanner: limitImgUrl('https://static.bakmigm.co.id/menu-buyer/order/horego-banner2-plp.jpg', 500),
//     idBanner: limitImgUrl('https://static.bakmigm.co.id/menu-buyer/order/horego-banner2-plp.jpg', 500),
//     bannerLink: 'https://horego.onelink.me/BDBE/hz0dwevl',
//   }
]

// TODO: 临时垃圾代码
const shopeePromoConfig = [
  {
    start: new Date('2023/12/1 00:00:00'),
    end: new Date('2023/12/31 23:59:59'),
    enBanner: limitImgUrl('https://static.bakmigm.co.id/menu/Promo_Banner/December_EN.jpg', 500),
    idBanner: limitImgUrl('https://static.bakmigm.co.id/menu/Promo_Banner/December_ID.jpg', 500),
    bannerLink: 'https://desty.page/paylaterpromo',
    enText: 'Cashback available. T&C Apply',
    idText: 'Terdapat Cashback. S&K berlaku.',
  },
  {
    start: new Date('2023/11/1 00:00:00'),
    end: new Date('2023/11/30 23:59:59'),
    enBanner: limitImgUrl('https://static.bakmigm.co.id/menu/Promo_Banner/November_EN.jpg', 500),
    idBanner: limitImgUrl('https://static.bakmigm.co.id/menu/Promo_Banner/November_ID.jpg', 500),
    bannerLink: 'https://desty.page/paylaterpromo',
    enText: 'Cashback available. T&C Apply',
    idText: 'Terdapat Cashback. S&K berlaku.',
  },
  // {
  //   start: new Date('2023/9/27 00:00:00'),
  //   end: new Date('2023/9/27 15:00:00'),
  //   enBanner: limitImgUrl('https://static.bakmigm.co.id/menu/Promo_Banner/shopee_131_en.jpg', 500),
  //   idBanner: limitImgUrl('https://static.bakmigm.co.id/menu/Promo_Banner/shopee_131_id.jpg', 500),
  //   bannerLink: 'https://desty.page/paylaterpromo',
  //   enText: 'Cashback available. T&C Apply',
  //   idText: 'Terdapat Cashback. S&K berlaku.',
  // },
]
const currentConfigs = shopeePromoConfig.filter(it => isWithinInterval(new Date(), { start: it.start, end: it.end }))
const openShopeePayPromo = (function () {
  return currentConfigs.length !== 0;
}())
console.log('OPEN_SHOPEE:', openShopeePayPromo);
export function getExtraBanner(vm) {
  const banners = bannerConfig.map(curr => {
    const lang = vm.$store.state.Menu.language;
    const banner = lang === 'id-ID' ? curr.idBanner : curr.enBanner;
    return { imgSrc: banner, link: curr.bannerLink }
  })
  return banners;
}
export function addShopeePayPromo(vm, payments) {
  if (!openShopeePayPromo) return payments;
  const tipMap = {
    'id-ID': currentConfigs[0].idText,
    'en-US': currentConfigs[0].enText
  }
  const promoTips = tipMap[vm?.$store?.state?.Menu?.language];
  return payments.map(it => {
    if (it.name === 'ShopeePay') return { ...it, promoTips, ignoreSetDefualtPay: true }
    return it;
  })
}


export function withGoogleCaptcha(fn, that) {
  window.grecaptcha.enterprise.ready(() => {
    window.grecaptcha.enterprise.execute('6Ld-M0MpAAAAAIPLZFnEOKe0Yv9XuauKn8hVFJyL', { action: 'login' }).then((token) => {
      if (that) {
        fn.call(that, token);
      } else {
        fn.call(null, token);
      }
    }).catch(e => {
      console.log('GOOGLE_TOKEN_ERROR: ', e)
    });
  });
}
export function callGoogleCaptcha() {
  return new Promise((resolve, reject) => {
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute('6Ld-M0MpAAAAAIPLZFnEOKe0Yv9XuauKn8hVFJyL', { action: 'login' }).then((token) => {
        resolve(token)
      }).catch(e => {
        console.log('GOOGLE_TOKEN_ERROR: ', e);
        reject(e)
      });
    });
  })
}

export const getDeviceType = () => {
  const { userAgent } = navigator; // 获取User Agent信息
  if (/(iPhone|iPad|iPod)/i.test(userAgent)) {
    return 'IOS'
  } if (/android/i.test(userAgent)) {
    return 'ANDROID'
  }
    return 'OTHERS'
}
